import { FRUITFUL_ENV } from '../config/config';
import { FruitfulEnvironment } from '../config/FruitfulEnvironment';

/**
 * Provides the base url for the fruitful web app (e.g. https://my.fruitful.com)
 * @returns the url, using a type compatible with expo-router's Link component
 */
export function getWebUrl(): `${string}:${string}` {
    let url: `${string}:${string}`;

    switch (FRUITFUL_ENV as FruitfulEnvironment) {
        case FruitfulEnvironment.PRODUCTION:
            url = 'https://my.fruitful.com';
            break;
        case FruitfulEnvironment.STAGING:
            url = 'https://stg.fruitful.com';
            break;
        case FruitfulEnvironment.SANDBOX:
            url = 'https://sandbox.fruitful.com';
            break;
        default:
            url = 'http://localhost:8081';
            break;
    }

    return url;
}

export function getWebUrlWithoutProtocol(): string {
    return getWebUrl().replace(/^https?:\/\//, '');
}
